import { UploadSignedVerdictFormValues } from './uploadSignedVerdictFormTypes';

export const buildUploadSignedVerdictFormData = (formValues: UploadSignedVerdictFormValues) => {
  const formData = new FormData();
  formData.append('signedVerdictFile', formValues.signedVerdictFile!);
  return formData;
};
